//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";


import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';
import loadmore from '@/components/ui/loadmore';
import dialogbox from '@/components/ui/dialogbox';
import mainMenuTab from "@/components/mainMenuTab";

import editAddress from './editAddress.vue';

export default {
    components: {mainMenuTab,cardbox,navbar,loadmore,dialogbox,editAddress},
    data(){
        return {
            address: [],
            addData: {
                buttonText: '确认',
                title: '新增收货地址',
                show: false,
                type: 'add',
                style: 'height:100%; width:100%; margin:auto; border-radius:0;'
            },
            addrInfo: {
                consignee: '',
                region_id: '',
                region_name: '',
                address: '',
                zipcode: '',
                phone_mob: '',
                is_default: 0,
                locate_addr: '',
                lng: '0',
                lat: '0',
                print_addr: '0',
                town_code: '',
            },
        }
    },
    methods:{

        // 打开地址操作面板
        openAddrDialog(type,item){

            if(type==='add'){
                this.addData.title = '新增收货地址';
                this.addData.type = 'add';
                this.addrInfo = {
                    consignee: '',
                    region_id: '',
                    region_name: '',
                    address: '',
                    zipcode: '',
                    phone_mob: '',
                    is_default: 0,
                    locate_addr: '',
                    lng: '0',
                    lat: '0',
                    print_addr: '0',
                    town_code: '',
                }
            }else{
                this.addData.title = '修改收货地址';
                this.addData.type = 'edit';
                this.addrInfo = {
                    addr_id: item.addr_id,
                    user_id: item.user_id,
                    consignee: item.consignee,
                    region_id: item.region_id,
                    region_name: item.region_name,
                    address: item.address.split(' | ')[1] || '',
                    zipcode: item.zipcode,
                    phone_mob: item.phone_mob,
                    is_default: item.is_default,
                    locate_addr: item.locate_addr,
                    lng: item.lng,
                    lat: item.lat,
                    print_addr: item.print_addr || '0',
                    town_code: item.town_code,
                }
            }

            console.log(this.addrInfo);

            this.addData.show = true;
        },

        // 设置为默认
        setDefault(item){

            item.is_default = 1;
            item.print_addr = item.print_addr || "0";

            const opts = {
                url: api.myAddressMod,
                data: {
                    ...item
                },
                type: 'put'
            }

            common.query(opts).then(res=>{
                this.queryAddress();
            },res=>{
                this.$vux.toast.text(res.message)
            })
        },

        // 删除地址
        delAddress(item){

            const _this = this;
            const opts = {
                url: api.myAddressDel,
                data: {
                    addr_id: item.addr_id,
                },
                type: 'delete'
            }

            this.$vux.confirm.show({
                title: '删除确认',
                onConfirm () {
                    common.query(opts).then(res=>{
                        _this.queryAddress();
                    },res=>{
                        _this.$vux.toast.text(res.message)
                    })
                }
            })
        },

        // 查询地址列表
        queryAddress(){

            const opts = {
                url: api.myAddress,
                data: {},
                type: 'get'
            }
            common.query(opts).then(res=>{

                this.address = res.data;

                const str = common.storage("userInfo") || "{}";
                const info = JSON.parse(str);

                if(res.data.length>0){
                    info.no_addr = 0;
                    common.storageJson("userInfo",info);
                }else{
                    info.no_addr = 1;
                    common.storageJson("userInfo",info);
                }


            },res=>{
                this.$vux.toast.text(res.message);
            });
        },

    },
    mounted(){

        this.queryAddress();

    },
}




// WEBPACK FOOTER //
// ./src/views/member/address.vue